var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCyphlens(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.17955 1.58209C0.0651011 2.73613 0.00779039 4.82903 1.00056 7.40248C1.98358 9.95068 3.96067 12.8599 6.70789 15.5129C9.45512 18.1658 12.4316 20.0402 15.0125 20.9337C17.6191 21.836 19.7087 21.7057 20.8231 20.5517C21.9376 19.3976 21.9949 17.3047 21.0021 14.7313C20.0191 12.1831 18.042 9.27385 15.2948 6.62089C12.5476 3.96792 9.5711 2.09357 6.99015 1.20008C4.38362 0.297727 2.294 0.428045 1.17955 1.58209ZM1.76445 7.10779C0.795546 4.59619 1.00896 2.9374 1.76852 2.15085C2.52808 1.3643 4.17841 1.09313 6.7223 1.97379C9.16726 2.82021 12.0446 4.62046 14.726 7.20986C17.4074 9.79925 19.307 12.612 20.2382 15.026C21.2071 17.5376 20.9937 19.1964 20.2341 19.9829C19.4746 20.7694 17.8243 21.0406 15.2804 20.16C12.8354 19.3135 9.95805 17.5133 7.27666 14.9239C4.59526 12.3345 2.69568 9.52173 1.76445 7.10779Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Gradient Circle",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9608 7.0009C20.9197 4.51516 20.6527 3.01145 20.02 2.35627C19.3873 1.70109 17.8938 1.38175 15.3762 2.25335C12.9804 3.08274 10.1389 4.8562 7.48129 7.42259C4.82371 9.98898 2.95217 12.7669 2.03967 15.1322C1.08074 17.618 1.34776 19.1217 1.98046 19.7769C2.61316 20.4321 4.10664 20.7514 6.62433 19.8798C9.02011 19.0504 11.8616 17.2769 14.5192 14.7106C17.1768 12.1442 19.0483 9.36628 19.9608 7.0009ZM15.4994 15.7256C21.0415 10.3737 23.5199 3.94917 21.0351 1.37606C18.5502 -1.19705 12.0432 1.05563 6.50108 6.40755C0.959002 11.7595 -1.51939 18.184 0.965426 20.7571C3.45025 23.3302 9.95733 21.0775 15.4994 15.7256Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCyphlens);
export default __webpack_public_path__ + "static/media/cyphlens.c78f4450477d8b08e8010d17102ccddc.svg";
export { ForwardRef as ReactComponent };